<template>
  <DrawablePhotoV1OrV2
    v-if="!loading"
    :photo-class="'question-signature-drawing'"
    :image="imageObject"
    :drawing="drawing"
    :width="480"
    :height="240"
    :show-thumbnail="false"
    :colors="[{ color: '#000000', marker: '#ffffff' }]"
    :title="$t('Sign here')"
    :remove-button-title="$t('Remove signature')"
    :can-be-deleted="false"
    @change="updateDrawing"
  />
</template>

<script>
  import { DrawablePhotoV1OrV2 } from '@/_legacy/components/DrawablePhoto/DrawablePhotoV1OrV2';
  import * as AssetsPhotoStateService from '@/services/assets-api/AssetsPhotoStateService';

  export default {
    components: { DrawablePhotoV1OrV2 },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        loading: false,
      };
    },
    computed: {
      drawing() {
        return this.item.response && this.item.response.drawing ? this.item.response.drawing : null;
      },
      imageObject() {
        return {
          drawing: this.drawing,
          drawing_id: this.item.response?.drawing_id,
        };
      },
    },
    methods: {
      removeDrawing() {
        const photoToDelete = this.item.response;
        if (!photoToDelete) {
          return;
        }

        AssetsPhotoStateService.deleteDrawing(photoToDelete);

        this.$delete(this.item, 'response');
        this.$set(this.item, 'responded', false);
      },
      updateDrawing(drawing) {
        this.loading = true;

        if (!drawing) {
          this.removeDrawing();

          this.loading = false;
          return;
        }

        const photoToUpdate = this.item.response || {};

        AssetsPhotoStateService.updateDrawing(photoToUpdate, drawing);

        this.$set(this.item, 'response', { ...photoToUpdate });
        this.$set(this.item, 'responded', true);
        this.loading = false;
      },
    },
  };
</script>
